import { AbstractStore } from '@deqo/foundation';
import { useCallback, useMemo } from 'react';
import { useObserver } from '../CodesThatsGottaGoSomewhereElse';

class MutableValueStore<T> extends AbstractStore<{ value: T }> {
    protected state: { value: T };

    constructor(initialState: { value: T }) {
        super();
        this.setState(initialState);
    }

    public mutateTo(newState: { value: T }): void {
        this.setState(newState);
    }
}

const stores = new Map<string, MutableValueStore<any>>();

const read = (key: string) => {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : null;
};

const write = (key: string, value: any) => {
    localStorage.setItem(key, JSON.stringify(value));
};

export const useLocalSettings = <T>(key: string, defaultValue?: T) => {

    const store = useMemo(() => {
        if (!stores.has(key)) {
            const initial = read(key) || (defaultValue === undefined ? {} : defaultValue);
            stores.set(key, new MutableValueStore({ value: initial }));
        }
        return stores.get(key) as MutableValueStore<T>;
    }, [key]);

    const { value } = useObserver(store);

    const update = useCallback((next: T) => {
        write(key, next);
        store.mutateTo({ value: next });
    }, [key]);

    return [value, update] as const;
};
